module.exports = __webpack_public_path__ + "img/grocery.24873240.png";